/**
 * Loading messages that cycle during search/streaming operations
 */

export const LOADING_MESSAGES = [
  'Searching...',
  'Digging through results...',
  'Scanning the knowledge base...',
  'Finding the best matches...',
  'Sifting through the data...',
  'Almost there...',
  'Looking far and wide...',
  'Connecting the dots...',
  'Rummaging through pages...',
  'Hunting down answers...',
];

/** Interval in ms between loading message changes */
export const LOADING_MESSAGE_INTERVAL_MS = 2500;
